<div class="grid">
    <div class="col-12">
        <p-toolbar styleClass="header-background">
            <ng-template pTemplate="start">

                <div class="flex flex-column ">
                    <div class="flex "><img src="../../assets/images/postnord.svg" /></div>
                </div>
            </ng-template>
            <ng-template pTemplate="center">
            </ng-template>
            <ng-template pTemplate="end">
                <div class="flex align-items-center gap-2">
                    <p-button label="Log In" styleClass="header-button primary-btn-bg" (onClick)="login()" />
                </div>
            </ng-template>
        </p-toolbar>
    </div>
</div>
<app-carousel></app-carousel>
